// import { createContext, useContext, useEffect, useState } from "react";
// import AxiosService from "../Utils/AxiosService";

// const LanguageContext = createContext();

// export const LanguageProvider = ({ children, labelId }) => {
//   const apiService = new AxiosService();
//   const [languages, setLanguages] = useState(null);
//   const [selectedLanguage, setSelectedLanguage] = useState("@none");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (!labelId) return;

//     const fetchLanguages = async () => {
//       try {
//         setLoading(true);
//         const fields = await apiService.getLanguageDetails(labelId);
//         console.log("Restricted fields API:", fields);
//         setLanguages(fields || null);
//       } catch (error) {
//         console.error("Error fetching fields:", error);
//         setLanguages(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchLanguages();
//   }, [labelId]);

//   return (
//     <LanguageContext.Provider
//       value={{
//         languages,
//         selectedLanguage,
//         setSelectedLanguage,
//         loading,
//       }}
//     >
//       {children}
//     </LanguageContext.Provider>
//   );
// };

// export const useLanguage = () => useContext(LanguageContext);

import React, { createContext, useContext } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children, languages, loading }) => {

  return (
    <LanguageContext.Provider
      value={{ languages, loading}}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
